import { ia } from 'lib/helpers/utility';
import {
  CARD_ON_FILE_REQUIRED_MESSAGE,
  LOW_ASSURANCE_RESPONSE_CODES
} from 'lib/constants/healthcareProgram/fields';

export const DEFAULT_PAYMENT_ERROR = "The payment couldn't be processed. Please try again.";

// Raised when billing the cart's catalog items came to a different total than the button showed.
export const AMOUNT_CHANGED_CODE = 'amount-changed';

const toText = (value) => {
  if (typeof value === 'string') return value.trim();
  if (typeof value === 'number') return String(value);
  if (!value || typeof value !== 'object') return '';
  return toText(value.message) || toText(value.error) || '';
};

const toLines = (value) => (ia(value) ? value.map(toText) : [toText(value)]).filter(Boolean);

/**
 * `onError` is reached with a string (+ code), a server response (`{ code, error }`, where
 * `error` may be a list of messages), or a caught failure (`{ error, retryData }`). The modal
 * needs one shape: `{ error, errors, code, retryData }`.
 */
export const normalizePaymentError = (response, code) => {
  // Handlers that already alerted resolve with nothing; there is nothing more to show.
  if (response == null && code == null) return null;

  const isObject = !!response && typeof response === 'object' && !ia(response);
  const source = isObject ? (response.error ?? response.message) : response;
  const resolvedCode = (isObject ? response.code : undefined) ?? code ?? 1;
  const lines =
    resolvedCode === LOW_ASSURANCE_RESPONSE_CODES.CARD_ON_FILE_REQUIRED
      ? [CARD_ON_FILE_REQUIRED_MESSAGE]
      : toLines(source);

  return {
    error: lines.join(' ') || DEFAULT_PAYMENT_ERROR,
    errors: lines.length > 1 ? lines : null,
    code: resolvedCode,
    retryData: isObject ? (response.retryData ?? null) : null
  };
};
